import { temFormaDeUuid } from './uuid';

/** Retorno do login permitido para a sentença; a API continua autorizando a pessoa no documento. */
export function destinoSentencaPortal(valor: string | null | undefined): string | undefined {
  if (!valor) return undefined;
  const parteId = /^\/portal\/arbitragem\/([^/]+)\/sentenca$/.exec(valor)?.[1];
  return parteId && temFormaDeUuid(parteId) ? valor : undefined;
}

/** Preserva a sentença em uma etapa do login sem aceitar redirecionamentos externos. */
export function comDestinoSentencaPortal(caminho: string, destino?: string): string {
  const retorno = destinoSentencaPortal(destino);
  if (!retorno) return caminho;
  return `${caminho}${caminho.includes('?') ? '&' : '?'}redirect=${encodeURIComponent(retorno)}`;
}
